export default {
  // actions
  FETCH_FIELDS: 'FETCH_FIELDS',
  FETCH_RESULTS: 'FETCH_RESULTS',
  // mutations
  DATE_FILTER: 'DATE_FILTER',
  EVENT_FILTER: 'EVENT_FILTER',
  EVENT_RUNNERS: 'EVENT_RUNNERS',
  FIELD: 'FIELD',
  FIELDS: 'FIELDS',
  HASH: 'HASH',
  INFO: 'INFO',
  PRESET: 'PRESET',
  PRESETS: 'PRESETS',
  RESET: 'RESET',
  RESULTS: 'RESULTS',
  SORT: 'SORT',
  STATUS: 'STATUS',
  TOTAL_COUNT: 'TOTAL_COUNT',
  QUERY: 'QUERY',
  // states
  EVENT_DISABLED: 'disabled',
  EVENT_ENABLED: 'enabled',
  EVENT_NOT_READY: 'disabled-until-event-start-closer',
  ERROR_INIT: 'ERROR_INIT', // Could not start (no fields)
  ERROR_FETCH: 'ERROR_FETCH', // Could not fetch reults
  RESULTS_NONE: 'RESULTS_NONE', // No selections returned
  STARTED: 'STARTED', // First render (no previous state)
  STARTING: 'STARTING', // Loading fields & previous state
  // routes
  ROUTE_INDEX: 'ROUTE_INDEX',
  ROUTE_SEARCH: 'ROUTE_SEARCH',
  // options
  SORT_NAME: 'SORT_NAME',
  SORT_TIME: 'SORT_TIME',
};
